import React from 'react';
import { Select, Spin,AutoComplete } from 'antd';
import debounce from 'lodash/debounce';
import { getCouponsList } from '../../modules/Api';
import './couponRemoteSelect.css';


const { Option } = Select;

class CouponRemoteSelect extends React.Component {
  constructor(props) {
    super(props);
    this.lastFetchId = 0;
    // this.fetchCoupon = debounce(this.fetchCoupon, 800);
    this.state = {
      data: [],
      value: props.value,
      fetching: false,
    };
    this.init = false;
  }

  fetchCoupon = value => {
    this.lastFetchId += 1;
    const fetchId = this.lastFetchId;
    this.setState({ data: [], fetching: true });

    getCouponsList(`is_lucky=1&title=${value}&per_page=50`, function(body) {
      if (fetchId !== this.lastFetchId) {
        // for fetch callback order
        return;
      }
      let data = [{value: 0, text: "پوچ"}];

       body.data.data.map(coupon => (data[data.length] = {
        text: `${coupon.title} ${coupon.content} ${coupon.brand.name}`,
        value: coupon.id,
      }));
      this.setState({ data: data, fetching: false });
    }.bind(this))
  }

  handleChange = (value, option) => {
    this.props.selectChanged(value);
    this.setState({
      value,
      data: [],
      fetching: false,
    });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value && this.init === false) {
      this.init = true;
      this.setState({ value: nextProps.value });
    }
  }

  render() {
    const { fetching, data, value } = this.state;
    return (
      <AutoComplete
        defaultValue={value}
        placeholder="انتخاب کوپن"
        notFoundContent={fetching ? <Spin size="small" /> : null}
        open={data.length > 0}
        onFocus={()=>{this.fetchCoupon('')}}
        onBlur={()=>{this.setState({data: []})}}
        onSearch={this.fetchCoupon}
        onSelect={this.handleChange}
        style={{ width: '100%', direction: 'rtl', textAlign: 'right', float: 'right' }}
      >
          {data.map(d => (
          <AutoComplete.Option style={{ width: '100%', direction: 'rtl', textAlign: 'right', float: 'right' }} key={d.value}>{d.text}</AutoComplete.Option>
        ))}
        </AutoComplete>
    );
  }
}

export default CouponRemoteSelect



// WEBPACK FOOTER //
// ./src/containers/LuckyWheels/CouponRemoteSelect.js